import Repository from "./repository";

const resource = "twilio";

export default {
    async rejectRecord( payload ) {
        let endpoint = `${resource}/record/reject`;
        let response = await Repository.post(endpoint, payload);
        return response;
    },
}